import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { constants } from "../../store/rentIncrease";
import {
  useFilteredApartments,
  overviewUrl as apartmentOverviewUrl,
  useApartment,
  constants as apartmentConstants,
} from "../../store/apartments";
import {
  OverviewSubtitle,
  OverviewTitle,
  OverviewTitleWithSubtitleWrapper,
  OverviewTitleWrapper,
} from "../../components/Details/OverviewInfo/styles";
import { PrimaryButton, TextButton } from "../../components/Forms/Base/Buttons";
import StandardModal from "../../components/Modals/StandardModal";
import {
  DetailInnerWrapper,
  DetailPageBox,
  InnerBox,
} from "../../components/sharedStyles";
import useActiveFilters from "../../hooks/useActiveFilters";
import { buildQueryString } from "../../store/base";

import {
  addApartment,
  addMultipleApartments,
  performApartmentUpdate,
  removeApartment,
  setApartmentIncreaseDateForId,
  setApartmentIncreases,
} from "../../store/rentIncrease/store/actions";
import PremisesTable from "../../components/PremisesTable/PremisesTable";
import NonConnectedNumberInput from "../../components/Forms/Base/Old/NonConnected/NonConnectedNumberInput";
import NonConnectedDatePicker from "../../components/Forms/Base/Old/NonConnected/NonConnectedDatePicker";
import { cloneDeep } from "lodash";
import { RemoveButton } from "../../components/Billecta/Invoices/InvoiceComponents/Multiple/styles";
import { InfoBox } from "../../components/Displays";
import useQuery from "../../components/utils/useQuery";
import OverlaySpinner from "../../components/Loaders/OverlaySpinner";
import { useHistory } from "react-router-dom";
import RentIncreaseGuide from "../../components/Details/Apartment/RentIncreaseGuide";
import { addToast, TOAST_TYPES } from "../../store/toasts";
import NonConnectedRentField from "../../components/Forms/Base/Old/NonConnected/NonConnectedRentField";
import ConfirmationModal from "../../components/Modals/ConfirmationModal";
import moment from "moment";
import { toMoneyString } from "../../components/utils/stringUtils";
import { PRODUCT_CATEGORIES } from "../../store/invoicingProducts";
import ApartmentTable from "src/components/Tables/Apartments/FullTableNewVersion";
import Modal from "src/components/Forms/Base/Modals/Modal";
import PrimaryBtn from "src/components/Forms/Base/Buttons/PrimaryBtn";
import LocalTextInputField from "src/components/Forms/Base/Fields/LocalTextInputField";
import LocalCheckField from "src/components/Forms/Base/Fields/LocalCheckField";
import OptionsModal from "src/components/Forms/Base/Modals/OptionsModal";
import { HomeIcon } from "@heroicons/react/24/outline";
import { BuildingOffice2Icon } from "@heroicons/react/24/outline";
import RealEstateTable from "src/components/Tables/RealEstate/FullTable";
import { axiosInstance } from "src/store/base/store/axios";

const EDIT_ALL_TYPES = {
  PERCENTAGE: "PERCENTAGE",
  SEK: "SEK",
  DATES: "DATES",
};

export default function ApartmentRentIncrease() {
  const storeName = constants.STORE_NAME;
  const dispatch = useDispatch();
  const { filteredRealEstates } = useActiveFilters();
  const [loading, setLoading] = React.useState(false);
  const [infoOpen, setInfoOpen] = React.useState(false);
  const [canSave, setCanSave] = React.useState(false);
  const [optionsOpen, setOptionsOpen] = React.useState(false);
  const [selectorOpen, setSelectorOpen] = React.useState(false);
  const [multiSelectorOpen, setMultiSelectorOpen] = React.useState(false);
  const [selectedRealEstates, setSelectedRealEstates] = React.useState([]);
  const [hasSetFromQuery, setHasSetFromQuery] = React.useState(false);
  const [isEditingAll, setIsEditingAll] = React.useState(false);
  const [editAllSek, setEditAllSek] = React.useState(null);
  const [editAllPercent, setEditAllPercent] = React.useState(null);
  const [editAllDate, setEditAllDate] = React.useState(null);
  const [confirmationOpen, setConfirmationOpen] = React.useState(false);

  const [retroActivePeriods, setRetroActivePeriods] = React.useState(1);
  const [retroActiveCappedForContract, setRetroActiveCappedForContract] =
    React.useState(false);
  const { push } = useHistory();

  const query = useQuery();

  const realEstate = query.get("realestate");
  const building = query.get("building");
  const apartment = query.get("apartmentid");

  const realEstateQueryObj = {
    realestate_ids: realEstate ? [realEstate] : [],
  };
  if (!realEstate) {
    realEstateQueryObj.id = -1;
  }

  const buildingQueryObj = {
    building: building,
  };
  if (!building) {
    buildingQueryObj.id = -1;
  }
  const realEstateQuery = buildQueryString(realEstateQueryObj);
  const buildingQuery = buildQueryString(buildingQueryObj);

  // get eventual apartments from eventual query
  const [apartmentsMatchingRealEstate, realEstateMatchingLoading] =
    useFilteredApartments(realEstateQuery);
  const [apartmentsMatchingBuilding, buildingMatchingLoading] =
    useFilteredApartments(buildingQuery);
  const [singularApartment] = useApartment(apartment);

  const increases = useSelector((state) => state[storeName].increases);

  React.useEffect(() => {
    if (hasSetFromQuery) return;

    const combined = [
      ...(apartmentsMatchingBuilding || []),
      ...(apartmentsMatchingRealEstate || []),
    ];

    if (singularApartment) {
      combined.push(singularApartment);
    }

    if (combined?.length) {
      setHasSetFromQuery(true);

      dispatch(addMultipleApartments({ apartments: combined }));
    }
  }, [
    apartmentsMatchingRealEstate,
    apartmentsMatchingBuilding,
    singularApartment,
  ]);

  React.useEffect(() => {
    if (increases.length) {
      const anyRowHasError = increases.find((i) => !i.base_rent);

      if (anyRowHasError) {
        setCanSave(false);
      } else {
        setCanSave(true);
      }
    }
  }, [increases]);

  React.useEffect(() => {
    return () => {
      dispatch(setApartmentIncreases({ newIncreases: [] }));
    };
  }, []);

  const checkRowHighlighted = (original) => {
    let match = false;

    match = increases?.find((s) => s.id === original.id);

    return match;
  };

  const checkRealEstateRowHighlighted = (original) => {
    let match = false;

    match = selectedRealEstates?.find((s) => s.id === original.id);

    return match;
  };

  const onSelected = (original) => {
    if (increases.find((i) => i.id === original.id)) {
      dispatch(removeApartment({ apartment: original }));
    } else {
      dispatch(addApartment({ apartment: original }));
    }
  };

  const clearNonValidPremises = () => {
    let newIncreases = cloneDeep(increases);

    newIncreases = newIncreases.filter((i) => !!i.base_rent);

    dispatch(setApartmentIncreases({ newIncreases }));
  };

  const onRealEstateSelected = (original) => {
    let clone = cloneDeep(selectedRealEstates);
    if (selectedRealEstates?.find((r) => r.id === original.id)) {
      clone = clone.filter((r) => r.id !== original.id);
    } else {
      clone.push(original);
    }

    setSelectedRealEstates(clone);
  };

  const handleAddApartmentsFromRealEstates = async () => {
    setMultiSelectorOpen(false);
    setLoading(true);

    try {
      const url = apartmentConstants.LIST_URL;
      const query = buildQueryString({
        realestate_ids: selectedRealEstates?.map((r) => r.id) || [],
      });
      const qUrl = `${url}?${query}`;

      const { data } = await axiosInstance.get(qUrl);

      dispatch(addMultipleApartments({ apartments: data }));

      setLoading(false);
      setSelectedRealEstates([]);
      dispatch(
        addToast({
          type: TOAST_TYPES.SUCCESS,
          title: "Lägenheterna lades till",
        })
      );
    } catch (e) {
      setLoading(false);

      dispatch(
        addToast({
          type: TOAST_TYPES.ERROR,
          title: "Kunde ej lägga till lägenheter under fastigheter",
        })
      );
    }
  };

  const handleIncreaseUpdated = ({ id, val, totalCost }) => {
    const newIncreases = cloneDeep(increases);

    const cur = newIncreases.find((obj) => obj.id === id);

    const quota = ((val / totalCost) * 100).toFixed(2);

    cur.quota = quota;
    cur.increase_in_sek = val;
    cur.new_rent = (parseFloat(totalCost) + parseFloat(val)).toFixed(2);

    dispatch(setApartmentIncreases({ newIncreases }));
  };

  const handleIncreasePercentageUpdated = ({ id, val, totalCost }) => {
    const newIncreases = cloneDeep(increases);

    const cur = newIncreases.find((obj) => obj.id === id);

    const increaseInSek = (totalCost * (val / 100)).toFixed(2);

    cur.quota = val;
    cur.increase_in_sek = increaseInSek;
    cur.new_rent = (parseFloat(totalCost) + parseFloat(increaseInSek)).toFixed(
      2
    );

    dispatch(setApartmentIncreases({ newIncreases }));
  };

  const handleNewRentUpdated = ({ id, val, totalCost }) => {
    const newIncreases = cloneDeep(increases);
    const cur = newIncreases.find((obj) => obj.id === id);

    const increaseInSek = val - totalCost.toFixed(2);
    const quota = (increaseInSek / totalCost) * 100;

    cur.quota = quota;
    cur.increase_in_sek = increaseInSek;
    cur.new_rent = val;

    dispatch(setApartmentIncreases({ newIncreases }));
  };

  const handleApplyFromUpdates = ({ id, val }) => {
    dispatch(setApartmentIncreaseDateForId({ id, val }));
  };

  const handleEditAllPercentageUpdated = (val) => {
    setEditAllPercent(val);
    setEditAllSek(0);
  };

  const handleEditAllSekUpdated = (val) => {
    setEditAllPercent(0);
    setEditAllSek(val);
  };

  const handleEditAllApplyFromDates = (val) => {
    setEditAllDate(val);
  };

  const handleSetAll = () => {
    const newIncreases = cloneDeep(increases);
    let val;

    if (isEditingAll === EDIT_ALL_TYPES.SEK) {
      val = editAllSek;
      newIncreases.forEach((i) => {
        if (!i.base_rent) return;
        const quota = ((val / i.base_rent) * 100).toFixed(2);

        i.quota = quota;
        i.increase_in_sek = val;
        i.new_rent = parseFloat(i.base_rent) + parseFloat(val);
      });
    } else if (isEditingAll === EDIT_ALL_TYPES.PERCENTAGE) {
      val = editAllPercent;
      newIncreases.forEach((i) => {
        if (!i.base_rent) return;

        const increaseInSek = (i.base_rent * (val / 100)).toFixed(2);

        i.quota = val;
        i.increase_in_sek = increaseInSek;
        i.new_rent = parseFloat(i.base_rent) + parseFloat(increaseInSek);
      });
    } else if (isEditingAll === EDIT_ALL_TYPES.DATES) {
      newIncreases.forEach((i) => {
        if (!i.base_rent) return;

        i.apply_from = editAllDate;
      });

      dispatch(setApartmentIncreases({ newIncreases: [] }));
    }

    // timeout for date update to work, otherwise date comps spams updates
    setTimeout(() => {
      dispatch(setApartmentIncreases({ newIncreases }));
    }, 100);
    setIsEditingAll(false);
  };

  const handleCreate = () => {
    setLoading(true);
    dispatch(
      performApartmentUpdate({
        retroActivePeriods,
        retroActiveCappedForContract,
        successCallback: () => {
          setLoading(false);

          dispatch(
            addToast({
              type: TOAST_TYPES.SUCCESS,
              title: "Hyreshöjningen sparades",
            })
          );
          push(apartmentOverviewUrl());
        },
        errorCallback: () => {
          setLoading(false);

          dispatch(
            addToast({
              type: TOAST_TYPES.ERROR,
              title: "Något gick fel",
              description: "Kontrollera datan och försök igen",
            })
          );
        },
      })
    );
  };

  const premisesHeaders = [
    "",
    "Lgh. nr.",
    "Obj. nr.",
    "Ref. hyra (SEK/mån)",
    "Förändring (SEK/mån)",
    "Förändring (%)",
    "Ny ref. hyra",
    "Genomförs",
  ];

  let errorRowIndexes = React.useMemo(() => {
    let indexes = [];
    increases.forEach((apartment, idx) => {
      if (!apartment.base_rent) {
        indexes.push(idx);
      }
    });

    return indexes;
  }, [increases]);

  const premisesRows = React.useMemo(() => {
    return increases.map((apartment, idx) => {
      const baseDate = moment(apartment.apply_from);
      const costsOnDate = apartment.cost_set?.filter((c) => {
        if (
          ![
            PRODUCT_CATEGORIES.BASE_RENT,
            PRODUCT_CATEGORIES.RENT_INCREASE,
          ].includes(c.product?.category)
        )
          return false;

        if (c.start_date) {
          const costStartDate = moment(c.start_date);
          if (costStartDate.isAfter(baseDate)) return false;
        }

        if (c.end_date) {
          const costEndDate = moment(c.end_date);
          if (costEndDate.isBefore(baseDate)) return false;
        }

        return true;
      });

      const totalCost = costsOnDate?.reduce(
        (acc, cur) => acc + (cur.value || 0),
        0
      );

      const row = [
        <RemoveButton onClick={() => onSelected(apartment)} />,
        apartment.apartment_id,
        apartment.premises_id || "-",
        totalCost ? toMoneyString(totalCost, true) : "-",
        <NonConnectedNumberInput
          disabled={!totalCost}
          value={apartment.increase_in_sek}
          onUpdate={(val) =>
            handleIncreaseUpdated({ id: apartment.id, val, totalCost })
          }
          rowSize
          noTitle
          noMargin
          id={`inc_${apartment.id}`}
        />,
        <NonConnectedNumberInput
          disabled={!totalCost}
          value={apartment.quota}
          onUpdate={(val) =>
            handleIncreasePercentageUpdated({
              id: apartment.id,
              val,
              totalCost,
            })
          }
          rowSize
          noTitle
          noMargin
          id={`inc_proc_${apartment.id}`}
        />,
        <NonConnectedRentField
          disabled={!totalCost}
          value={apartment.new_rent}
          onUpdate={(val) => handleNewRentUpdated({ id: apartment.id, val })}
          rowSize
          noTitle
          hideCalculations
          noMargin
          key={idx}
          area={apartment.area || null}
          id={`inc_newrent_${apartment.id}`}
        />,
        <NonConnectedDatePicker
          disabled={!totalCost}
          value={apartment.apply_from}
          onChange={(val) => {
            handleApplyFromUpdates({ id: apartment.id, val });
          }}
          noMargin
          rowSize
          clearable={false}
          id={`inc_apply_${apartment.id}`}
        />,
      ];

      return row;
    });
  }, [increases]);

  return (
    <>
      <ConfirmationModal
        isOpen={confirmationOpen}
        title="Bekräfta tillägg av hyreshöjningar"
        renderContent={() => (
          <div>
            Observera att denna åtgärd inte går att ångra. Hyreshöjningar
            påverkar debiteringsrader på avtal som är kopplade till de
            hyreshöjda objekten och därmed även eventuell avisering kopplat till
            avtalen.
          </div>
        )}
        closeFunction={() => setConfirmationOpen(false)}
        acceptCallback={handleCreate}
        acceptTitle="Fortsätt"
      />

      {optionsOpen && (
        <OptionsModal
          closeFunction={() => setOptionsOpen(false)}
          title={"Välj alternativ"}
          info="Välj om enskilda lägenheter ska läggas till eller lägenheter under hela fastigheter."
          onOptionSelected={(o) => {
            switch (o.id) {
              case "singular": {
                setSelectorOpen(true);
                setOptionsOpen(false);
                break;
              }

              case "multi": {
                setMultiSelectorOpen(true);
                setOptionsOpen(false);
                break;
              }
            }
          }}
          options={[
            {
              title: "Välj enskilda lägenheter",
              Icon: HomeIcon,
              id: "singular",
            },
            {
              title: "Välj fastigheter",
              Icon: BuildingOffice2Icon,
              id: "multi",
            },
          ]}
        />
      )}

      <StandardModal
        isOpen={infoOpen}
        closeFunction={() => setInfoOpen(false)}
        title="Hur fungerar hyreshöjning?"
        withActionBar
        actionBarCancelTitle="Stäng"
      >
        <RentIncreaseGuide />
      </StandardModal>

      {selectorOpen && (
        <Modal
          closeFunction={() => setSelectorOpen(false)}
          title="Välj hyreslägenheter"
        >
          <ApartmentTable
            ignoreLocalStorage
            onRowClicked={onSelected}
            checkRowHighlighted={checkRowHighlighted}
            persistantQuery={{
              realestate_ids: filteredRealEstates,
            }}
            withCosts={false}
          />
        </Modal>
      )}

      {multiSelectorOpen && (
        <Modal
          closeFunction={() => setMultiSelectorOpen(false)}
          title="Välj fastigheter"
          canAccept={selectedRealEstates?.length > 0}
          acceptTitle="Lägg till objekt under valda fastigheter"
          onAccept={handleAddApartmentsFromRealEstates}
        >
          <RealEstateTable
            ignoreLocalStorage
            onRowClicked={onRealEstateSelected}
            checkRowHighlighted={checkRealEstateRowHighlighted}
            persistantQuery={{
              realestate_ids: filteredRealEstates,
            }}
          />
        </Modal>
      )}

      <DetailInnerWrapper>
        <DetailPageBox>
          {(loading ||
            realEstateMatchingLoading ||
            buildingMatchingLoading) && <OverlaySpinner />}
          <OverviewTitleWrapper>
            <OverviewTitleWithSubtitleWrapper>
              <OverviewTitle>Hyreshöjning av hyreslägenheter</OverviewTitle>
              <OverviewSubtitle>
                <TextButton
                  iconType="info"
                  title="Hur fungerar hyreshöjning?"
                  clicked={() => setInfoOpen(true)}
                />
              </OverviewSubtitle>
            </OverviewTitleWithSubtitleWrapper>

            <PrimaryBtn onClick={() => setOptionsOpen(true)}>
              Lägg till lägenheter
            </PrimaryBtn>
          </OverviewTitleWrapper>

          {!isEditingAll && (
            <>
              <TextButton
                title="Ställ in hyreshöjning i SEK för samtliga lägenheter i listan"
                iconType="edit"
                iconPlacement="right"
                clicked={() => setIsEditingAll(EDIT_ALL_TYPES.SEK)}
              />

              <TextButton
                title="Ställ in hyreshöjning i % för samtliga lägenheter i listan"
                iconType="edit"
                iconPlacement="right"
                clicked={() => setIsEditingAll(EDIT_ALL_TYPES.PERCENTAGE)}
                extraStyle={{ margin: "12px auto 0 0 " }}
              />

              <TextButton
                title="Ställ in datum för höjning för samtliga lägenheter i listan"
                iconType="edit"
                iconPlacement="right"
                clicked={() => setIsEditingAll(EDIT_ALL_TYPES.DATES)}
                extraStyle={{ margin: "12px auto 0 0 " }}
              />
            </>
          )}

          {isEditingAll && (
            <>
              <div style={{ display: "flex", alignItems: "center" }}>
                {isEditingAll === EDIT_ALL_TYPES.SEK && (
                  <NonConnectedRentField
                    id="edit_all_sek"
                    title="Höjning i SEK"
                    value={editAllSek}
                    extraStyles={{ minWidth: 500 }}
                    onUpdate={(val) => handleEditAllSekUpdated(val)}
                  />
                )}
                {isEditingAll === EDIT_ALL_TYPES.PERCENTAGE && (
                  <NonConnectedNumberInput
                    id="edit_all_percentage"
                    label="Höjning i %"
                    value={editAllPercent}
                    extraStyle={{ minWidth: 300 }}
                    onUpdate={(val) => handleEditAllPercentageUpdated(val)}
                  />
                )}
                {isEditingAll === EDIT_ALL_TYPES.DATES && (
                  <NonConnectedDatePicker
                    label="Datum för höjning"
                    value={editAllDate}
                    onChange={(val) => handleEditAllApplyFromDates(val)}
                    clearable={false}
                    id={`inc_apply_all_`}
                  />
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <PrimaryButton
                  title="Ställ in för alla lägenheter i listan"
                  clicked={handleSetAll}
                />
                <span style={{ margin: "0 8px" }}>eller</span>
                <TextButton
                  title="Avbryt"
                  extraStyle={{ color: "#ea5050" }}
                  clicked={() => setIsEditingAll(false)}
                />
              </div>
            </>
          )}

          <InnerBox className="mt-4">
            <OverviewTitleWrapper>
              <OverviewTitleWithSubtitleWrapper>
                <OverviewTitle small>
                  Hantering av retroaktiv hyreshöjning
                </OverviewTitle>
                <OverviewSubtitle>
                  Ställ in hur eventuell retroaktiv hyreshöjning ska hanteras.
                </OverviewSubtitle>
              </OverviewTitleWithSubtitleWrapper>
            </OverviewTitleWrapper>
            <div>
              <div className="grid grid-cols-2 gap-6 mb-6">
                <LocalTextInputField
                  isNumber
                  step="1"
                  title="Fördela retroaktiv höjning över ... månader"
                  description="Den retroaktiva höjningen kan fördelas ut över x antal månader. en retrokaktiv höjning på 9 000SEK fördelat över 3 månader kommer fördelas till 3 000SEK per månad kommande 3 aviserade månader. Vid kvartals/års-avisering är det fortfarande månader som räknas."
                  value={retroActivePeriods}
                  onChange={(val) => setRetroActivePeriods(val)}
                />
              </div>

              <div className=" mb-6">
                <LocalCheckField
                  title="Begränsa fördelning till sista avtalsdag"
                  description="Om detta är aktivt kommer fördelning max kunna sättas till återstående månader på ett avtal. Exempel: Fördelningen är inställd på 3 månader, men den nuvarande hyresgästen flyttar ut om 2 månader. Då sätts fördelningen till 2 månader för just det objektet."
                  value={retroActiveCappedForContract}
                  onChange={(val) => setRetroActiveCappedForContract(val)}
                />
              </div>
            </div>
          </InnerBox>

          {errorRowIndexes?.length > 0 && (
            <InfoBox
              boxTheme="warning"
              title={`${errorRowIndexes.length} ${
                errorRowIndexes?.length === 1 ? "lägenhet" : "lägenheter"
              } saknar referenshyra`}
              renderButton={{
                title: "Rensa alla rödmarkerade rader",
                iconType: "close",
                iconPlacement: "right",
                clicked: () => clearNonValidPremises(),
              }}
              text="För att kunna genomföra en hyreshöjning krävs det att lägenheten har en referenshyra att utgå igrån. Ta bort de rödmarkerade raderna och åtgärda detta inne på respektive lägenhet"
            />
          )}

          <PremisesTable
            extraContainerStyles={{ marginTop: 20 }}
            headers={premisesHeaders}
            rows={premisesRows}
            loading={false}
            errorRowIndexes={errorRowIndexes}
            keyMapping={increases?.map((i) => i.id)}
          />

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <PrimaryButton
              disabled={!canSave}
              title={`Registrera hyreshöjningar för ${increases?.length} hyreslägenheter`}
              clicked={() => setConfirmationOpen(true)}
            />
          </div>
        </DetailPageBox>
      </DetailInnerWrapper>
    </>
  );
}
